import policies from "../../../../web-sh/src/pages/admin/policies/components";

import MasterPasswordRequirements from "./MasterPasswordRequirements";

const policiesComponents = {
  ...policies,
  MasterPasswordRequirements
}

export default policiesComponents